/* eslint-disable camelcase */
import Vue from 'vue';
import Vuex from 'vuex';
import pathify from 'vuex-pathify';
import actingUser from './actingUser';
import mode from './mode';
import authorizedUser from './authorizedUser';
import products from './products'; // this is legacy, before app #8
import users from './users';
import login_attempts from './login_attempts';
import comments from './comments'; // depricated. TBD - move SupplierQuality app from this api to comments.comments
// @depricated
import apps from './apps';
import ci_brokers from './ci/brokers';
import ci_instructors from './ci/instructors';
import ci_rule_types from './ci/rule_types';
import ci_rule_condition_types from './ci/rule_condition_types';
import ci_rules from './ci/rules';
import ci_rule_conditions from './ci/rule_conditions';
import ci_classes from './ci/classes';
import ci_classes_overbooked from './ci/classes_overbooked';
import ci_classes_soldout_with_broker_bookings from './ci/classes_soldout_with_broker_bookings';
import ci_classes_that_sold_out from './ci/classes_that_sold_out';
import ci_classes_mismatched_with_classpass_com from './ci/classes_mismatched_with_classpass_com';
import ci_classes_mismatched_with_consumer_classpass_com from './ci/classes_mismatched_with_consumer_classpass_com';
import ci_classes_mismatched_with_studio_classpass_com from './ci/classes_mismatched_with_studio_classpass_com';
import ci_classes_mismatched_between_consumer_and_studio_classpass_com from './ci/classes_mismatched_between_consumer_and_studio_classpass_com';
import ci_classes_disabled_on_classpass_com from './ci/classes_disabled_on_classpass_com';
import ci_classes_with_overrides from './ci/classes_with_overrides';
import ci_classes_with_standby_capacity from './ci/classes_with_standby_capacity';
import ci_classes_with_converted_standby from './ci/classes_with_converted_standby';
import ci_classes_instructors_rel from './ci/classes_instructors_rel';
import ci_availability_tiers from './ci/availability_tiers';
import ci_availability from './ci/availability';
import ci_api_log from './ci/api_log';
import ci_acceptable_overbooking_levels from './ci/acceptable_overbooking_levels';
import ci_utilization_bands from './ci/utilization_bands';
import ci_class_metrics from './ci/class_metrics';
import ci_class_rooms from './ci/class_rooms';
import ci_studio_metrics from './ci/studio_metrics';
import ci_prediction_models from './ci/prediction_models';
import ci_reservations from './ci/reservations';
import ci_ci_pc_pns_res_by_source_date from './ci/ci_pc_pns_res_by_source_date';
import ci_broker_price_benchmark_products from './ci/broker_price_benchmark_products';
import ci_studios from './ci/studios';
import calendars_time_zones from './calendars/timeZones';
import meta_ui_menus from './meta/ui_menus';
import meta_ui_menus_user_defaults from './meta/ui_menus_user_defaults';
// import meta__table_views from './meta/table_views/table_views'
import controlled_actions_controlled_actions_tree from './controlled_actions/controlled_actions_tree';
import controlled_actions_roles from './controlled_actions/roles';
import role_assignments from './controlled_actions/role_assignments';
import controlled_actions_controlled_actions from 'src/apps/24PlatformAdmin/domains/controlled_actions/controlled_actions';
import controlled_actions_controlled_action_groups from 'src/apps/24PlatformAdmin/domains/controlled_actions/controlled_action_groups';
import controlled_actions_ca_cag_rel from 'src/apps/24PlatformAdmin/domains/controlled_actions/ca_cag_rel';
import controlled_actions_cag_apps_tenants_rel from 'src/apps/24PlatformAdmin/domains/controlled_actions/cag_apps_tenants_rel';
import products_product_levels_org_specific_labels from './products/product_levels_org_specific_labels';
import orgs_org_levels_org_specific_labels from './orgs/org_levels_org_specific_labels';
import preferences_options from './preferences/options';
import session_context from './sessionContext';
import users_login_attempts from './users/login_attempts';
import topBar from './topBar/topBar';
Vue.use(Vuex);
/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */
const Store = new Vuex.Store({
    plugins: [
        pathify.plugin
    ],
    modules: {
        topBar,
        actingUser,
        mode,
        authorizedUser,
        products,
        users,
        login_attempts,
        apps,
        comments,
        // @depricated
        'users.login_attempts': users_login_attempts,
        // @depricated
        'products.product_levels_org_specific_labels': products_product_levels_org_specific_labels,
        // @depricated
        'preferences.options': preferences_options,
        // @depricated
        'orgs.org_levels_org_specific_labels': orgs_org_levels_org_specific_labels,
        'sessionContext': session_context,
        'ci.brokers': ci_brokers,
        'ci.instructors': ci_instructors,
        'ci.rule_types': ci_rule_types,
        'ci.rules': ci_rules,
        'ci.rule_condition_types': ci_rule_condition_types,
        'ci.rule_conditions': ci_rule_conditions,
        'ci.classes': ci_classes,
        'ci.classes_overbooked': ci_classes_overbooked,
        'ci.classes_soldout_with_broker_bookings': ci_classes_soldout_with_broker_bookings,
        'ci.classes_that_sold_out': ci_classes_that_sold_out,
        'ci.classes_mismatched_with_classpass_com': ci_classes_mismatched_with_classpass_com,
        'ci.classes_mismatched_with_consumer_classpass_com': ci_classes_mismatched_with_consumer_classpass_com,
        'ci.classes_mismatched_with_studio_classpass_com': ci_classes_mismatched_with_studio_classpass_com,
        'ci.classes_mismatched_between_consumer_and_studio_classpass_com': ci_classes_mismatched_between_consumer_and_studio_classpass_com,
        'ci.classes_disabled_on_classpass_com': ci_classes_disabled_on_classpass_com,
        'ci.classes_with_overrides': ci_classes_with_overrides,
        'ci.classes_with_standby_capacity': ci_classes_with_standby_capacity,
        'ci.classes_with_converted_standby': ci_classes_with_converted_standby,
        'ci.classes_instructors_rel': ci_classes_instructors_rel,
        'ci.availability_tiers': ci_availability_tiers,
        'ci.availability': ci_availability,
        'ci.api_log': ci_api_log,
        'ci.acceptable_overbooking_levels': ci_acceptable_overbooking_levels,
        'ci.utilization_bands': ci_utilization_bands,
        'ci.class_metrics': ci_class_metrics,
        'ci.class_rooms': ci_class_rooms,
        'ci.studio_metrics': ci_studio_metrics,
        'ci.prediction_models': ci_prediction_models,
        'ci.reservations': ci_reservations,
        'ci.ci_pc_pns_res_by_source_date': ci_ci_pc_pns_res_by_source_date,
        'ci.broker_price_benchmark_products': ci_broker_price_benchmark_products,
        'ci.studios': ci_studios,
        'calendars.timeZones': calendars_time_zones,
        'meta.ui_menus': meta_ui_menus,
        'meta.ui_menus_user_defaults': meta_ui_menus_user_defaults,
        // 'meta.table_views': meta__table_views,
        'controlled_actions.controlled_actions': controlled_actions_controlled_actions,
        'controlled_actions.controlled_action_groups': controlled_actions_controlled_action_groups,
        'controlled_actions.ca_cag_rel': controlled_actions_ca_cag_rel,
        'controlled_actions.cag_apps_tenants_rel': controlled_actions_cag_apps_tenants_rel,
        'controlled_actions.controlled_actions_tree': controlled_actions_controlled_actions_tree,
        'controlled_actions.roles': controlled_actions_roles,
        'controlled_actions.roles_orgs_apps_to_users': role_assignments
    },
    actions: {
        // from https://github.com/vuejs/vuex/issues/1244#issuecomment-547971322
        bindNamespaces({ commit }, { _modulesNamespaceMap }) {
            Object.entries(_modulesNamespaceMap).forEach(([namespace, module]) => {
                commit('bindNamespace', { module, namespace });
            });
        }
    },
    mutations: {
        // from https://github.com/vuejs/vuex/issues/1244#issuecomment-547971322
        bindNamespace(_, { module, namespace }) {
            Vue.set(module.state, '_namespace', namespace);
        }
    }
});
export default Store;
